export default __webpack_public_path__ + "static/media/363.33cf12eb.jpg";